import { Building2, SearchCheck, FileSearch, FileSignature, FolderCheck, BadgeEuro } from "lucide-react";

const STEPS = [
  { icon: Building2, label: "Impresa" },
  { icon: SearchCheck, label: "Verifica" },
  { icon: FileSearch, label: "Relazione" },
  { icon: FileSignature, label: "Accordo a step" },
  { icon: FolderCheck, label: "Pratica" },
  { icon: BadgeEuro, label: "Incasso", finale: true },
];

export function FlussoGara() {
  return (
    <div className="rounded-xl bg-slate-100 backdrop-blur-md border border-slate-200 p-5" data-testid="flusso-card">
      <div className="flex items-center justify-between mb-4"><div className="text-xs text-slate-700">Dalla tua impresa all'incasso del contributo</div><div className="text-[10px] uppercase tracking-[0.15em] text-[#0070BA]">6 tappe · 1 team</div></div>
      <div className="relative">
        <svg className="absolute left-0 right-0 top-[22px] w-full h-2" viewBox="0 0 600 8" preserveAspectRatio="none" aria-hidden="true">
          <defs><linearGradient id="flow" x1="0" x2="1"><stop offset="0" stopColor="#003087" stopOpacity=".25" /><stop offset="1" stopColor="#0070BA" /></linearGradient></defs>
          <path d="M20 4 H580" stroke="url(#flow)" strokeWidth="3" strokeLinecap="round" strokeDasharray="8 7" className="flusso-dash" fill="none" />
        </svg>
        <ol className="relative grid grid-cols-6 gap-1">
          {STEPS.map(({ icon: Icon, label, finale }, i) => (
            <li key={label} className="flex flex-col items-center text-center fade-up" style={{ animationDelay: `${150 + i * 110}ms` }}>
              <span className={`h-11 w-11 rounded-full flex items-center justify-center border ${finale ? "bg-[#0070BA] text-white border-[#0070BA] shadow-[0_0_0_6px_rgba(0,112,186,.18)]" : "bg-slate-100 text-slate-900 border-slate-200"}`}><Icon size={18} strokeWidth={1.7} /></span>
              <span className={`mt-2 text-[11px] leading-tight ${finale ? "text-[#0070BA] font-semibold" : "text-slate-700"}`}>{label}</span>
            </li>))}
        </ol>
      </div>
    </div>
  );
}
